import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Flex, Typography, Box, Button, Card, CardTitle, CardContent, color } from '@kistech/kis-ui';
import { selectors as configSelectors, Configuration } from 'store/configurations';
import { LinkedContentDrawer } from './LinkedContentDrawer';
import { MediaText } from '../MediaText';
import { MediaTypes } from '../../../types';

interface LinkedContentProps {
  configuration: Configuration;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  attractLoop: any;
  isActive: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateConfig: (payload: any) => void;
  onDelete: () => void;
}

export const LinkedContent: React.FC<LinkedContentProps> = (props: LinkedContentProps) => {
  const { isActive, attractLoop, configuration } = props;
  const loading = useSelector(configSelectors.selectPending);
  const [showDrawer, setShowDrawer] = useState(false);

  const onMakeActive = () => {
    props.updateConfig({ type: MediaTypes.LINKED_CONTENT });
  };

  return (
    <>
      <LinkedContentDrawer
        isOpen={showDrawer}
        configuration={configuration}
        attractLoop={attractLoop}
        onClose={() => setShowDrawer(false)}
      />
      {attractLoop && attractLoop.linkedContentUrl ? (
        <Flex fullWidth>
          <Box width={650}>
            <Card raised hasBorderRadius>
              <CardTitle
                gutter={5}
                title={
                  <Flex direction="row" fullWidth justify="between">
                    <Typography size={18} weight={600}>
                      Linked Content
                    </Typography>
                    {isActive && !loading ? (
                      <Typography size={18} weight={600} color={color.PRIMARY}>
                        ACTIVE
                      </Typography>
                    ) : (
                      <Button size="x-small" appearance="primary" onClick={onMakeActive} isLoading={loading}>
                        Make Active
                      </Button>
                    )}
                  </Flex>
                }
              />
              <CardContent>
                <Box margin="0 3">
                  <Typography size={18}>Link Details</Typography>
                  <Typography size={14} style={{ wordBreak: 'break-all' }}>
                    URL: {attractLoop.linkedContentUrl}
                  </Typography>
                  <Box margin="6 0" />
                  <Flex direction="row" align="center" gutter={2}>
                    <Button
                      size="small"
                      width={200}
                      appearance="primary"
                      onClick={() => setShowDrawer(true)}
                      isLoading={loading}
                      data-testid="add-image-button"
                    >
                      Change Link
                    </Button>
                    <Button
                      size="small"
                      width={200}
                      appearance="white"
                      onClick={props.onDelete}
                      isLoading={loading}
                      data-testid="delete-button"
                    >
                      Delete
                    </Button>
                  </Flex>
                </Box>
              </CardContent>
            </Card>
          </Box>
        </Flex>
      ) : (
        <Box width={650}>
          <Card raised hasBorderRadius>
            <CardTitle
              gutter={5}
              title={
                <Typography size={18} weight={600}>
                  Linked Content
                </Typography>
              }
            />
            <CardContent>
              <MediaText mediaType={MediaTypes.LINKED_CONTENT} />
              <Box height={20} />
              <Flex fullWidth margin="3 0">
                <Box margin="0 3">
                  <Button
                    size="small"
                    width={200}
                    appearance="primary"
                    onClick={() => {
                      setShowDrawer(true);
                    }}
                    isLoading={loading}
                    data-testid="add-image-button"
                  >
                    Add Linked Content
                  </Button>
                </Box>
              </Flex>
            </CardContent>
          </Card>
        </Box>
      )}
    </>
  );
};
